import React, { useState } from "react";
import apiClient from "../../../../../api/apiClient";

const LeadEmailModal = ({ lead, onClose, onSent }) => {
    const [form, setForm] = useState({ subject: "", body: "" });
    const [sending, setSending] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState(false);

    const set = (f) => (e) => setForm((p) => ({ ...p, [f]: e.target.value }));

    const closeOnBackdrop = (e) => {
        if (e.target === e.currentTarget) onClose();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setSending(true);
        try {
            await apiClient.post(`/admin/crm/leads/${lead.id}/email`, form);
            setSuccess(true);
            setTimeout(() => { onSent?.(); onClose(); }, 1200);
        } catch (err) {
            setError(err.response?.data?.error || "Failed to send email");
        } finally {
            setSending(false);
        }
    };
    
    return (
        <div className="crm-modal-overlay" onClick={closeOnBackdrop}>
            <div className="crm-modal">
                <div className="crm-modal__header">
                    <h2 className="crm-modal__title">
                        ✉ Email {lead.firstName} {lead.lastName}
                    </h2>
                    <button className="crm-modal__close" onClick={onClose}>×</button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="crm-modal__body">
                        <div className="admin-form-group" style={{ marginBottom: 16 }}>
                            <label className="admin-form-label">To</label>
                            <input className="admin-form-input" value={lead.email} readOnly disabled />
                        </div>

                        {error && (
                            <div className="crm-email-banner crm-email-banner--error">{error}</div>
                        )}
                        {success && (
                            <div className="crm-email-banner crm-email-banner--success">✓ Email sent successfully.</div>
                        )}

                        <div className="admin-form-group" style={{ marginBottom: 16 }}>
                            <label className="admin-form-label">Subject <span style={{ color: "#ef4444" }}>*</span></label>
                            <input
                                className="admin-form-input"
                                required
                                value={form.subject}
                                onChange={set("subject")}
                                maxLength={300}
                                placeholder="Email subject"
                                autoFocus
                            />
                        </div>

                        <div className="admin-form-group">
                            <label className="admin-form-label">Message <span style={{ color: "#ef4444" }}>*</span></label>
                            <textarea
                                className="admin-form-input"
                                required
                                rows={9}
                                value={form.body}
                                onChange={set("body")}
                                style={{ resize: "vertical", lineHeight: 1.6 }}
                                maxLength={50000}
                                placeholder="Write your message here…"
                            />
                        </div>
                    </div>

                    <div className="crm-modal__footer">
                        <button type="button" className="admin-btn" onClick={onClose} disabled={sending}>
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="admin-btn admin-btn--primary"
                            disabled={sending || success}
                        >
                            {sending ? "Sending…" : "Send Email"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default LeadEmailModal;
